export default __webpack_public_path__ + "static/media/177.caafb5d2.png";